import { Callout } from './Primitives.tsx'

/** Below the board while its moves are not applied: use them, or drop them. */
export const PendingPoolsBar = ({ onApply, onDiscard }: { onApply: () => void; onDiscard: () => void }) => (
  <Callout className="flex flex-wrap items-center gap-2 rounded bg-amber-50 px-2 py-1.5" data-testid="wizard-pools-pending">
    <span className="text-slate-800">The pools changed — not applied to the order yet.</span>
    <button type="button" className="btn btn-sm btn-primary" data-testid="wizard-pools-apply" onClick={onApply}>
      Use these pools
    </button>
    <button type="button" className="btn btn-sm btn-ghost" data-testid="wizard-pools-discard" onClick={onDiscard}>
      Discard changes
    </button>
  </Callout>
)
